module.exports = __webpack_public_path__ + "img/light-Path 24@3x.4f276eaa.png";